import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import clsNames from 'classnames'

import analyticsUtils from '../../../helpers/analytics-utils'
import style from './index.scss'
import priceFormatter from './price-formatter'

const clickRetailer = retailerName => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.STORE_CLICK,
    eventCategory: analyticsUtils.categories.STORE_SELECTION,
    eventAction: retailerName,
  })
}

const ProductSummary = ({
  title,
  titleLink,
  productName,
  price,
  salePrice,
  compact,
  classNames,
}) => (
  <div
    className={clsNames(
      style.productSummary,
      compact ? style.compact : null,
      classNames.container
    )}
  >
    {titleLink ? (
      <Link
        to={titleLink}
        className={clsNames(style.title, classNames.title)}
        onClick={() => clickRetailer(title)}
      >
        {title}
      </Link>
    ) : (
      <div className={clsNames(style.title, classNames.title)}>{title}</div>
    )}
    <div
      className={clsNames(style.productName, classNames.productName)}
      dangerouslySetInnerHTML={{ __html: productName }}
    />
    <div
      className={clsNames(
        style.priceContainer,
        salePrice ? style.discounted : null,
        classNames.price
      )}
    >
      <div className={style.price}>{priceFormatter(price)}</div>
      {salePrice && (
        <div className={style.salePrice}>{priceFormatter(salePrice)}</div>
      )}
    </div>
  </div>
)

ProductSummary.propTypes = {
  title: PropTypes.string.isRequired,
  titleLink: PropTypes.string,
  productName: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  salePrice: PropTypes.number,
  compact: PropTypes.bool,
  classNames: PropTypes.object,
}

ProductSummary.defaultProps = {
  classNames: {},
}
export default ProductSummary
